export default __webpack_public_path__ + "static/media/banner.0dd7fe1b.png";